import { Inject, Injectable, InjectionToken } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';

export const COUNTRY_LIST = new InjectionToken<any[]>('COUNTRY_LIST');

@Injectable()
export class CountryPresetProvider {
  constructor(@Inject(COUNTRY_LIST) private countryOptions: any[]) {}
  getConfiguration(): FormlyFieldConfig {
    return {
      key: 'country',
      type: 'select',
      templateOptions: {
        label: 'Country',
        placeholder: 'Please Select',
        options: this.countryOptions.map((country) => ({ label: country.name, value: country.name })),
      },
    };
  }
}

export function registerCountryPreset(countryOptions: any[]): ConfigOption {
  return {
    presets: [
      {
        name: 'country',
        config: new CountryPresetProvider(countryOptions),
      },
    ],
  };
}